import React, { useState, useEffect, useMemo } from 'react';
import PageHeading from '../../components/PageHeading';
import { SearchOutlined, EditOutlined, DeleteOutlined, SketchOutlined } from '@ant-design/icons';
import axiosInstance from '../../utils/axios';
import { Button, Input, message, Popconfirm, Table } from 'antd';
import { dateFormat } from '../../utils/dateFormats';
import GenreModal from './GenreModal';

const Genre = () => {
	const [genre, setGenre] = useState([]);
	const [loading, setLoading] = useState(false);
	const [search, setSearch] = useState('');
	const [createModalOpen, setCreateModalOpen] = useState(false);
	const [selectedId, setSelectedId] = useState(null);

	useEffect(() => {
		fetchData();
	}, []);

	const openModalUpdate = (id) => {
		setSelectedId(id);
		setCreateModalOpen(true);
	};

	const openModalCreate = () => {
		setSelectedId(null);
		setCreateModalOpen(true);
	};

	const fetchData = async () => {
		setLoading(true);
		try {
			const response = await axiosInstance.get("core/genre/");
			setGenre(response.data);
		} catch (error) {
			message.error("Failed to fetch genre");
		} finally {
			setLoading(false);
		}
	};

	const cancel = () => message.info('Cancelled');

	const confirm = async (id) => {
		try {
			await axiosInstance.delete(`core/genre/${id}/`);
			message.success("Deleted successfully");
			setGenre(prev => prev.filter(item => item.id !== id));
		} catch (err) {
			message.error("Cannot delete");
		}
	};

	const filteredlanguages = useMemo(() => {
		return genre.filter(item =>
			item.name.toLowerCase().includes(search.toLowerCase())
		);
	}, [search, genre]);

	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
		},
		{
			title: 'Created at',
			dataIndex: 'created_at',
			key: 'created_at',
			render: text => dateFormat(text),
		},
		{
			title: 'Action',
			dataIndex: '',
			key: 'actions',
			render: (_, record) => record.restricted ? null : (
				<>
					<Button type="link" icon={<EditOutlined />}  onClick={() => openModalUpdate(record.id)} />
					<Popconfirm
						title="Delete"
						description="Are you sure to delete this item?"
						onConfirm={() => confirm(record.id)}
						onCancel={cancel}
						okText="Yes"
						cancelText="No"
					>
						<Button type="link" danger icon={<DeleteOutlined />} />
					</Popconfirm>
				</>
			)
		},
	];

	return (
		<div className='dashboard'>
			<PageHeading name="Genre" icon={<SketchOutlined/>} />

			<div style={{
				display: 'flex',
				flexWrap: 'wrap',
				gap: '12px',
				alignItems: 'center',
				justifyContent: 'space-between',
				marginBottom: 16
			}}>
				<Input
					placeholder="Search here"
					prefix={<SearchOutlined />}
					style={{ width: "190px" }}
					onChange={(e) => setSearch(e.target.value)}
				/>
				<Button type="primary" onClick={openModalCreate}>Add new</Button>
			</div>

			<Table
				dataSource={filteredlanguages}
				loading={loading}
				columns={columns}
				rowKey="id"
				pagination
			/>

			<GenreModal
				open={createModalOpen}
				setOpen={setCreateModalOpen}
				genre={genre}
				setGenre={setGenre}
				selectedId={selectedId}
			/>

		</div>
	)
}

export default Genre